import React, { Fragment } from 'react'
import CollectEmailPanel from '../home/CollectEmailPanel'
import LoginFormContainer from './LoginFormContainer'
import { selectCurrentLocationWithAddress } from '../../redux/modules/selectors'
import { loadLocationStart } from '../../redux/modules/location'
import { connect } from 'react-redux'

const styles = {
  Login: {
    padding: '32px',
    textAlign: 'center'
  },
  Join: {
    padding: '32px',
    textAlign: 'center'
  },
  Icon: {
    fontSize: '48px',
    position: 'relative',
    top: '12px'
  },
  Signup: {
    fontSize: '20px'
  },
  LargeIcon: {
    fontSize: '72px'
  }
}

const Login = ({
  loginTitle,
  path,
  signupMessage,
  toggleLoginAndJoin,
  toggleVisibility
}) => (
  <div className="row" data-gtm-elm-id="LoginOrJoinModal">
    <div className="col-xs-12 col-md-6 first-panel" style={styles.Login}>
      <h2 className="title">{loginTitle}</h2>
      <LoginFormContainer toggleVisibility={toggleVisibility} path={path} />
    </div>
    <div className="col-xs-12 col-md-6 second-panel" style={styles.Login}>
      <h2 className="title">Don't Have an Account?</h2>
      <p style={styles.Signup}>{signupMessage}</p>
      <p style={styles.LargeIcon}>
        <i className="icon-user" />
      </p>
      <button onClick={toggleLoginAndJoin} className="secondary">
        Create An Account
      </button>
    </div>
  </div>
)

const Join = ({
  joinTitle,
  locationId,
  loginMessage,
  path,
  toggleLoginAndJoin
}) => (
  <div className="row">
    <div className="col-xs-12 col-md-6 first-panel" style={styles.Join}>
      <h2 className="title">Already Signed Up?</h2>
      <p style={styles.Signup}>{loginMessage}</p>
      <p style={styles.LargeIcon}>
        <i className="icon-user" />
      </p>
      <button onClick={toggleLoginAndJoin} className="secondary">
        Login Now
      </button>
    </div>
    <div
      className="col-xs-12 col-md-6 second-panel"
      dtat-gtm-elm-id="JoinPanel"
      style={styles.Join}
    >
      <h2 className="title">{joinTitle}</h2>
      <CollectEmailPanel locationId={locationId} path={path} />
    </div>
  </div>
)

class LoginOrJoin extends React.Component {
  state = {
    showLogin: true
  }

  toggleLoginAndJoin = () => {
    this.setState({
      showLogin: !this.state.showLogin
    })
  }

  render() {
    const { locationId, toggleVisibility, dropoffId, ...rest } = this.props
    const { showLogin } = this.state
    return (
      <Fragment>
        {showLogin ? (
          <Login
            locationId={locationId}
            toggleLoginAndJoin={this.toggleLoginAndJoin}
            toggleVisibility={toggleVisibility}
            dropoffId={dropoffId}
            {...rest}
          />
        ) : (
          <Join
            toggleLoginAndJoin={this.toggleLoginAndJoin}
            locationId={locationId}
            dropoffId={dropoffId}
            {...rest}
          />
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const location = selectCurrentLocationWithAddress(state)
  return {
    location
  }
}

const mapDispatchToProps = {
  loadLocationStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginOrJoin)
